"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Clipboard_1 = __importDefault(require("./Clipboard"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = function (_a) {
  var value = _a.value,
      className = _a.className,
      render = _a.render,
      children = _a.children;

  var _b = react_1.useState(false),
      copied = _b[0],
      setCopied = _b[1];

  var handleClick = function handleClick() {
    Clipboard_1.default(window, document, window.navigator).copy(value);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 2000);
  };

  return react_1.default.createElement("button", {
    className: classnames_1.default('btn', className),
    onClick: handleClick
  }, typeof render === 'function' ? render(copied) : children ? children : react_1.default.createElement("i", null, copied ? 'Copied!' : 'Copy'));
};